import React, { useEffect } from "react";

import EntryComponent from "components/Entry";

const Entry = ({ title }) => {
	useEffect(() => {
		document.title = title;
	}, [title]);

	return (
		<>
			<EntryComponent />
		</>
	);
};

export default Entry;
